import React from 'react';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router-dom';

let breadcrumbListItems = [];

const Breadcrumbs = ({intl, breadcrumbItems}) => {
  breadcrumbListItems = [];
  const breadcrumbList = [
    <li className="breadcrumb__item" key='home'>
      <a className="breadcrumb__link" href="/">{intl.formatMessage({id: 'Breadcrumbs.Home'})}</a>
    </li>,
    <li className="breadcrumb__item" key='salary'>
      <Link className="breadcrumb__link" to='/salary/'>{intl.formatMessage({id: 'Breadcrumbs.Salary'})}</Link>
    </li>,
  ];
  addItem('/', intl.formatMessage({id: 'Breadcrumbs.Home'}));
  addItem('/salary/', intl.formatMessage({id: 'Breadcrumbs.Salary'}));

  if (breadcrumbItems && breadcrumbItems.length) {
    breadcrumbItems.forEach((item) => {
      breadcrumbList.push(
          <li className="breadcrumb__item" key={item.title}>
            <Link className="breadcrumb__link" to={item.url}>{item.title}</Link>
          </li>,
      );
      addItem(item.url, item.title);
    });
  }

  // Remove the link from the last element.
  const lastElement = breadcrumbList[breadcrumbList.length-1];
  breadcrumbList[breadcrumbList.length-1] = React.cloneElement(lastElement, {
    children: lastElement.props.children.props.children,
  });

  // Get the last but one breadcrumb element and add class to it.
  const lastButOneElement = breadcrumbList[breadcrumbList.length-2].props.children;
  const breadcrumbsMobile = React.cloneElement(lastButOneElement, {className: 'breadcrumb__link hidden--from-l'});

  return (
    <div className="navigation navigation--skip-navigation">
      <div className="navigation__bottom">
        <nav className="breadcrumb" id="mobile_first" aria-label="breadcrumb">
          {breadcrumbsMobile}
          <ul className="breadcrumb__list hidden--until-l">
            {breadcrumbList}
          </ul>
        </nav>
        {getScript()}
      </div>
    </div>
  );
};

/**
 * Add an item to breadcrumbList script.
 * @param {string} url of the item
 * @param {string} name of the item
 */
function addItem(url, name) {
  breadcrumbListItems.push({url: url, name: name});
}

/**
 * Get the breadcrumbList script.
 * @return {string} the breadcrumbList script output.
 */
function getScript() {
  const breadcrumbListScript = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [],
  };
  breadcrumbListItems.forEach((item, index) => {
    breadcrumbListScript.itemListElement.push({
      '@type': 'ListItem',
      'position': index + 1,
      'item': {
        '@id': `${process.env.REACT_APP_BASE_URL}${item.url}`, 'name': item.name,
      },
    });
  });
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{'__html': JSON.stringify(breadcrumbListScript)}}/>
    </>);
}

export default injectIntl(Breadcrumbs);
